/**
 * The type of (redux) action which toggles the visibility of the stress check panel.
 *
 * {
 *     type: TOGGLE_STRESS_CHECK_PANEL
 * }
 */
export const TOGGLE_STRESS_CHECK_PANEL = 'TOGGLE_STRESS_CHECK_PANEL';
/**
 * The type of (redux) action which starts stress data polling.
 *
 * {
 *     type: START_STRESS_POLLING
 * }
 */
export const START_STRESS_POLLING = 'START_STRESS_POLLING';
/**
 * The type of (redux) action which stops stress data polling.
 *
 * {
 *     type: STOP_STRESS_POLLING
 * }
 */
export const STOP_STRESS_POLLING = 'STOP_STRESS_POLLING';
/**
 * The type of (redux) action which updates stress data.
 *
 * {
 *     type: UPDATE_STRESS_DATA,
 *     payload: stressData
 * }
 */
export const UPDATE_STRESS_DATA = 'UPDATE_STRESS_DATA';
/**
 * The type of (redux) action which sets polling error.
 *
 * {
 *     type: SET_STRESS_POLLING_ERROR,
 *     payload: error
 * }
 */
export const SET_STRESS_POLLING_ERROR = 'SET_STRESS_POLLING_ERROR';
